import { Partner, Site, Device, Network, SiteGroup, Market } from '@/graphql/model/index';
import QueryBuilder from '@/graphql/QueryBuilder';
import GQ from '@/graphql/GQ';
import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';

export default {

    async setDirection({commit}, direction) {
        commit('setDirection', direction);
    },

    setCursor({commit}, cursor) {
        return new Promise((resolve) => {
            commit('setCursor', cursor);
            resolve();
        });
    },

    setReport({commit}, report) {
        return new Promise((resolve) => {
            commit('setReport', report);
            resolve();
        });
    },

    setLimit({ commit, dispatch, state }, limit) {
        return new Promise((resolve) => {
            commit('setLimit', limit);
            resolve();
        });
    },

    setSelectedFilters({ commit, dispatch, state }, selectedFilters) {
        commit('setSelectedFilters', selectedFilters);
    },

    setSelectedFilter({commit}, filter) {
        return new Promise((resolve) => {
            commit('setSelectedFilter', filter);
            resolve();
        });
    },

    setSelectedColumns({commit}, selectedColumns) {
        return new Promise((resolve) => {
            commit('setSelectedColumns', selectedColumns);
            resolve();
        });        
    },

    
    setFixedColumns({commit}, fixedColumns) {
        //return new Promise((resolve, reject) => {
            commit('setFixedColumns', fixedColumns);
        //    resolve();
        //});
        //console.time('action:setFixedColumns');        
        //let result = commit('setFixedColumns', fixedColumns);
        //console.timeEnd('action:setFixedColumns');
        //console.log(result);
        //return result;
    },

    setSortedColumns({commit}, sortedColumns) {
        return new Promise((resolve) => {
            commit('setSortedColumns', sortedColumns);
            resolve();
        });         
    },

    loadFilters({ commit, dispatch, state }) {

        return GQ.query({
                siteIdIn: Site.query({ filters: { status: '!ACTIVE' }, orderBy: 'name' }),
                sourceIdIn: Partner.query({ filters: { type: '!BUYING' }, orderBy: 'company' }),
                deviceIdIn: Device.query({ filters: { idNotIn: [-1] }, orderBy: { id: 'asc' } }),
                marketIdIn: Market.all({ orderBy: 'name' }),
            })
            .then(function (result) {
                let filters = {};
                _.each(result, (entities, type) => {
                    filters[type] = [];
                    entities.forEach(entity => {
                        let value = entity.id;
                        let title = null;
                        switch(type) {
                            case 'sourceIdIn':
                            title = entity.company;
                                break;

                            default:
                            title = entity.name;
                                break;
                        }

                        filters[type].push({
                            value: value,
                            title: title
                        });
                    })
                })
                commit('setFilters', filters);
            })
            .catch(onApiError)
    },

    loadReport({ commit, getters, state }) {

        let args = {
            filters: getters.appliedFilters,
            orderBy: state.sortedColumns
        };

        let requestedColumns = _.cloneDeep(state.selectedColumns);               
        requestedColumns.push('dateRangeIndex');

        if(requestedColumns.indexOf('adGroupName') !== -1 ) {
            requestedColumns.push('targetUrl');
            requestedColumns.push('finalUrl');
        }

        if(requestedColumns.indexOf('siteName') !== -1 ) {
            requestedColumns.push('siteId');
        }

        if(requestedColumns.indexOf('sourceName') !== -1 ) {
            requestedColumns.push('sourceId');
        }

        let direction = state.direction;
        ( direction === 'before' ) ? args.last = state.limit        : args.first = state.limit;
        ( direction !== null )     ? args[direction] = state.cursor : null;

        let qb    = new QueryBuilder();
        let query = qb.connection('adgroupReportTwo')
            .fields(requestedColumns.join(','))
            .args(args) 
            .edgesQuery();

        return GQ.query({report: query})
            .then(function(result) {
                commit('setReport', result.report);
            })
            .catch(onApiError)
    },
}

function onApiError(errorResponse) 
{
    let message = [];
    if( ! errorResponse.errors ) {
        message.push(errorResponse.message)
    } else {
        errorResponse.errors.forEach(function (error) {
            message.push(error.message);
        })
    }

    Vue.prototype.$notification.showWarning({
        title: 'API Error:',
        message: message.join("<br/>"),
        timeout: 10000
    });
}


// WEBPACK FOOTER //
// ./src/store/modules/adgroupReport2/actions.js